<template>
	<layout-splash>
		<div class="card">
			<div class="card-header">{{ __("All offers are updated") }}!</div>
		</div>
	</layout-splash>
</template>

<script>
export default {};
</script>
